import React, { useEffect, useState } from 'react'
import parse from 'html-react-parser'
import {
  IonImg
} from '@ionic/react'
import { ShareMenu } from '../../../components/common/ShareMenu'
import ContentButton from '../../../components/core/player-parts/ContentButton'
import './styles.scss'

const ReadHeader = (props) => {
  const { content } = props
  const [chapter, setChater] = useState(false)

  useEffect(() => {
    const _chapter = {
      audio_file: content.header.audio_file,
      audio_file_type: content.header.audio_file_type,
      banner_height: content.header.banner_height,
      banner_width: content.header.banner_width,
      date: content.header.date,
      episode_number: content.header.episode_number,
      id_content: content.header.id,
      id_media_file_type: content.header.id_media_file_type,
      id_product: content.header.id_product,
      id_serial: '',
      intro: content.header.intro,
      media_file_type: content.header.media_file_type,
      miniature_height: content.header.miniature_height,
      miniature_width: content.header.miniature_width,
      name: content.header.serial,
      photo: content.header.banner,
      photo_min: content.header.miniature,
      product: content.header.product,
      product_alias: content.header.product_alias,
      category: content.header.category,
      category_alias: content.header.category_alias,
      section: content.header.section,
      section_alias: content.header.section_alias,
      title: content.header.title,
      url_title: content.header.url_title,
      video_file: content.header.video_file,
      video_file_type: content.header.video_file_type
    }
    setChater(_chapter)
  }, [])

  return (
    <section className={`watch-player ${content.header.section_alias}`}>

      <section itemProp='publisher' itemScope itemType='http://schema.org/Organization'>
        <meta itemProp='url' content='https://yokradio.com/' />
        <meta itemProp='name' content='Yok Radio' />
        <div itemProp='logo' itemScope itemType='http://schema.org/ImageObject'>
          <meta itemProp='url' content='https://yokradio.com/assets/icon/android-chrome-1024x1024.png' />
        </div>
      </section>

      <div className='slideshow'>
        <figure itemProp='image' itemScope itemType='http://schema.org/ImageObject'>
          <meta itemProp='height' content={content.header.miniature_height} />
          <meta itemProp='width' content={content.header.miniature_width} />
          <meta itemProp='url' content={content.header.miniature} />
          <IonImg
            src={content.header.miniature}
            alt={`Portada del episodio ${content.header.title}`}
          />
          <section className='actions'>
            {chapter && <ContentButton size='lg' content={chapter} />}
            <ShareMenu
              title={content.header.title}
              intro={content.header.intro}
              tags={content.header.tags}
              section='Yok Radio'
            />
          </section>
        </figure>
        <figcaption>
          <h1
            itemProp='headline'
            className='title'
          >
            {content.header.title}
          </h1>
          {content?.header?.intro &&
            <>
              <p
                className='intro'
                itemProp='abstract'
              >
                {content.header.intro}
              </p>
              <meta itemProp='abstract' content={content.header.intro} />
            </>}
          {content?.header?.intro_html &&
            <div
              className='intro html'
              itemProp='abstract'
            >
              {parse(content.header.intro_html)}
            </div>}
        </figcaption>
      </div>
    </section>
  )
}

export default ReadHeader
